import { useEffect, useState } from "react";
import { AppBar, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { Box } from "@mui/material/node_modules/@mui/system";
import { Brand, Country, getBrands, getCountries } from "api";
import { CountrySelector } from "components/CountrySelector/CountrySelector";
import useStyles from './DesktopMobileHeader.style';
import { useIntl } from "react-intl";

interface DesktopMobileHeaderProps {
  activeCountry?: Country,
  setCountry: (country?: Country) => void,
  activeBrand?: Brand,
  setBrand: (brand?: Brand) => void,
}

export function DesktopMobileHeader({
  activeCountry,
  setCountry,
  activeBrand,
  setBrand,
}: DesktopMobileHeaderProps) {
  const classes = useStyles();
  const intl = useIntl();
  const [brands, setBrands] = useState<Brand[]>([]);
  const [countries, setCountries] = useState<Country[]>([]);

  useEffect(() => {
    getBrands().then((brands) => {
      setBrands(brands);
    })
  }, [setBrands]);

  useEffect(() => {
    if (activeBrand) {
      getCountries().then(results => {
        setCountries(results.filter(({ brandId }) => activeBrand.id === brandId));
      });
    }
  }, [activeBrand]);

  return (
    <>
      <AppBar position="absolute" className={classes.appBar}>
        <Box className={classes.menu}>
          <Link to="/">
            <Button size="small" className={classes.menuItem}>
            {intl.formatMessage({ id: 'mobile.button.backToAdmin' })}
            </Button>
          </Link>
          <Box style={{ flex: 1 }} />
          <Box className={classes.countrySelector}>
            <CountrySelector
              activeBrand={activeBrand}
              brands={brands}
              activeCountry={activeCountry}
              countries={countries}
              setActiveBrand={setBrand}
              setActiveCountry={setCountry}
            />
          </Box>
        </Box>
      </AppBar>
      <Box className={classes.headerSpacer} />
    </>
  )
}